export default __webpack_public_path__ + "static/IN-8015_16mm_lense_night_hardwareWDR-c92014d789bf58c4e2405ed82f30ef67.webp";